'use client';
import { Cimage } from '@/components/ui/Cimage';
import type { WitnessCardData } from '@/components/ui/Cwitnesscard';
import { CWITNESSCARDMODAL_IMAGE_STYLE, getCwitnesscardmodalImageContainerStyle, getCwitnesscardmodalImageGradientStyle, } from './cwitnesscardmodalStyles';
interface CwitnesscardmodalImagePanelProps {
    card: WitnessCardData;
    isMobile: boolean;
}
export function CwitnesscardmodalImagePanel({ card, isMobile, }: CwitnesscardmodalImagePanelProps) {
    return <div data-el="Cwitnesscardmodal/ImagePanel/Root" style={getCwitnesscardmodalImageContainerStyle(isMobile)}>
            <Cimage src={card.imageSrc} alt={card.title} static={true} animation="none" objectFit="cover" width="100%" height="100%" style={CWITNESSCARDMODAL_IMAGE_STYLE}/>
            <div style={getCwitnesscardmodalImageGradientStyle(isMobile)} aria-hidden="true"/>
        </div>
        ;
}
